export default __webpack_public_path__ + "static/target-66c3651b1ac0cbbc882d0f75112bbe92.webp";